export enum PondStatus {
  Active = 'active',
  Completed = 'completed',
}

export enum PondTab {
  Setting = 'cycle',
  Album = 'album',
  Dashboard = 'dashboard',
  Summary = 'summary',
  Food = 'food',
  Growth = 'growth',
  Water = 'water',
  Partial = 'partial',
  DeadShrimp = 'dead_shrimp',
  Medicine = 'medicine',
  Cost = 'cost',
  Sales = 'sales',
}

/**
 * The order the pond tabs are rendered in (TAB_LIST in PondDetailPage, plus the
 * Album and Summary tabs it injects). Use it to pick which tab to land on —
 * useAllowPondTabs() returns permission order, which is not display order.
 */
export const POND_TAB_ORDER: PondTab[] = [
  PondTab.Dashboard,
  PondTab.Album,
  PondTab.Food,
  PondTab.Growth,
  PondTab.Partial,
  PondTab.Water,
  PondTab.DeadShrimp,
  PondTab.Summary,
  PondTab.Medicine,
  PondTab.Cost,
  PondTab.Sales,
  PondTab.Setting,
]

export enum PondTypeAlbum {
  All = 'all',
  Water = 'water',
  Tray = 'yor',
  DeadShrimp = 'dead_shrimp',
}

export const Feature = {
  food: 'อาหาร',
  growth: 'การเติบโต',
  waterquality: 'คุณภาพน้ำ',
  deadshrimp: 'กุ้งตาย',
  medicine: 'เวชภัณฑ์',
  shrimpsales: 'ขายกุ้ง',
}

export enum SpeciesType {
  Shrimp = 1,
  Fish = 2,
}

export enum SpeciesName {
  Shrimp = 'กุ้ง',
  Fish = 'ปลา',
}